export function getFontSize(transformer) {
    return Object.freeze({
        xxxl: transformer.fontSize('36px'),
        xxl: transformer.fontSize('28px'),
        xl: transformer.fontSize('24px'),
        l: transformer.fontSize('20px'),
        m: transformer.fontSize('16px'),
        s: transformer.fontSize('14px'),
    });
}
